import React from 'react'
import Header from '../Header/Main'
import Breadcrumb from '../Breadcrumb/Main'
import Hydrodtls from '../MenserviceHydro/Hydrodtls'
import Footer from '../Footer/Main'
import DigitalHiringSolutions from '../DigitalHiringSolutions/DigitalHiringSolutions'

function Main() {
    return (
        <>
            <div className="page-wrapper">
                <Header />
                <Breadcrumb subtitle="Home" title="Digital Hiring Solutions" />
                <DigitalHiringSolutions />
                <Footer />
            </div>
        </>
    )
}

export default Main